import script from "./GradientCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GradientCard.vue?vue&type=script&setup=true&lang=js"

import "./GradientCard.vue?vue&type=style&index=0&id=6024500c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6024500c"]])

export default __exports__